<script lang="ts">
</script>

<div
	class="inline-block bg-black rounded px-1.5 pt-0.5 text-xs text-fx-red border border-fx-grey-600 font-normal"
>
	Ended
</div>
